import {
    Component, Input, OnChanges, TemplateRef,
} from '@angular/core';
import { Store } from '@ngrx/store';

import { Category } from '@core/domain/models/category.models';
import { CorePlatformService } from '@core/infrastructure/platform/platform.service';
import { MenuCategory } from '@shared/header/models/category.model';
import { GoToCategory } from '@shared/navigation';

@Component({
    selector: 'category-sub-categories-special',
    templateUrl: './category-sub-categories-special.component.html',
})
export class CategorySubCategoriesSpecialComponent implements OnChanges {
    @Input() public categoryName: string;

    @Input() public selectGridView: TemplateRef<any>;

    @Input() public showFilters: boolean;

    @Input() public subCategories: Category[] | MenuCategory[] = [];

    @Input() public siblingCategories: MenuCategory[];

    @Input() public currentCategoryFromABTest: MenuCategory;

    @Input() public lastSectionTranslated: string;

    @Input() public showDebugCategoryIds: boolean;

    @Input() public direction: string;

    @Input() public showCategoryTitle = true;

    private readonly isBrowser = this.platformService.isBrowser();

    constructor(
        private readonly store: Store,
        private readonly platformService: CorePlatformService,
    ) { }

    public ngOnChanges(): void {
        if (this.currentCategoryFromABTest) {
            this.siblingCategories = this.siblingCategories.map((sibling) => {
                return {
                    ...sibling,
                    isActive: sibling.subCategoryIds?.includes(this.currentCategoryFromABTest.id),
                };
            });
        }
    }

    public goToCategory(category: MenuCategory, e?: MouseEvent): void {
        e?.stopPropagation();
        e?.preventDefault();
        const id = category.redirectToCategoryId ? category.redirectToCategoryId : category.id;
        this.store.dispatch(GoToCategory({ categoryId: id }));
    }

    public scrollToCurrentCategory(specialSubcategoryList: HTMLElement): void {
        if (this.isBrowser) {
            setTimeout(() => {
                const currentCategory = specialSubcategoryList.querySelector('.is-active');
                if (currentCategory) {
                    currentCategory.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                }
            }, 100);
        }
    }
}
